import React from "react";
// import SvgIcon from "../../components/library/SvgIcon/SvgIcon.js";
import ProgressBar from "../../components/library/ProgressBar/index.js";

// import VSCode from "../../assets/imgs/vscode.png";
// import G910 from "../../assets/imgs/g910.png";
// import G502 from "../../assets/imgs/g502.png";

import "./style.scss";

const Uses = () => {
  return (
    <div className='uses__container'>
      <ProgressBar />

      <header>
        <h1 className='align-c page-masthead '>Uses</h1>
      </header>

      <main>
        <section className='uses__harware'>
          <h2 className='title'>Hardware</h2>

          <p className='heading__intro'>
            <q>What I tend to use on a daily basis for work, personal projects or messing around whenever I get down time.</q>
          </p>

          <div className='columns is-multiline'>
            <article className='column is-half '>
              <h3>Machines</h3>

              <ul>
                <li>MacBook Pro M4 15" 24GB RAM 1TB SSD</li>
              </ul>
            </article>

            <article className='column is-half'>
              <h3>Phones</h3>
              <ul>
                <li>Pixel 10 Pro Fold</li>
                <li>Samsung S20+</li>
                <li>iPhone 12</li>
              </ul>
            </article>

            <article className='column is-half '>
              <h3>External Devices</h3>
              <ul>
                <li>Synology DS2920+ in RAID 6</li>
                <li>Icy Box IB-3620U3 External 2 Bay JBOD System</li>
                <li>2 x Western Digital 2TB HDD Blue</li>
                <li>Ultra High Capacity 22400mAh Power Bank (5.5A)</li>
                <li>2 X HooToo HT-UH010 7-Port USB 3.0 Hub</li>
              </ul>
            </article>

            <article className='column is-half'>
              <h3>Accessories</h3>
              <ul>
                <li>StarTech Dual DisplayPort to Thunderbolt 3 Adapter 4K 60Hz</li>
                <li>Kanex USB C to Gigabit Ethernet Adapter</li>
                <li>Apple USB-C Digital AV Multiport Adapter</li>
                <li>CAT6 Ethernet Gigabit Patch Cable</li>
                <li>ASUS RT-AX82U AX5400 Dual Band WiFi 6 Gaming Router</li>
              </ul>
            </article>

            <article className='column is-half '>
              <h3>Monitors</h3>
              <ul>
                <li>2 x PHILIPS 21.5\" 226E9QHAB</li>
              </ul>
            </article>

            <article className='column is-half'>
              <h3>Keyboard</h3>
              <ul>
                <li>Keychron K10</li>
                <li>AKAI LPK25 Portable MIDI Keyboard</li>
              </ul>
            </article>

            <article className='column is-half'>
              <h3>Mouse</h3>
              <ul>
                <li>Logitech G502 HERO</li>
                <li>Pepperoni Pizza Mouse Mat</li>
              </ul>
            </article>

            <article className='column is-half'>
              <h3>Sound</h3>
              <ul>
                <li>Soundcore Liberty 4 Nc </li>
              </ul>
            </article>
          </div>
        </section>

        <section className='uses__enviroment'>
          <h2 className='title'>Dev - Enviroment</h2>

          <p className='heading__intro'>
            <q>
              Over the past decade the IDE I use has changed from humble beginings such as <strike>DW & Frontpage onto </strike> Sublime then on to ATOM and finally VSCode. I was reluctant at first but its I doubt I will move away from it anytime shortly, specially with the{" "}
              <a href='https://gist.github.com/mark-vb-austin/b9fec803e5a431d8ae1a96af3d3b3179#file-extensions-json' className='link--bright' target='_blank' title='open link to extension gist list on Github' rel='noopener noreferrer'>
                vast amount of Extentions I use.
              </a>
            </q>
          </p>

          <div className='columns is-multiline'>
            <article className='column is-half '>
              <h3>VSCode</h3>
              <ul>
                <li>
                  Theme:  Monokai Pro (Spectrum)
                </li>
                <li>
                  Font: Fira Code
                </li>
                
              </ul>
            </article>

            <article className='column is-half '>
              <h3>Haxor</h3>
              <ul>
                <li>
                  Terminal: iTerm 2
                </li>
                <li>
                  Shell: Oh-my-Zsh
                </li>
              </ul>
            </article>
          </div>
        </section>

        <section className='uses__photograpghy'>
          <h2 className='title'>Photograpghy / Videography</h2>

          <p className='heading__intro'>
            <q>
              Has always been a pashion of mine, but it does become a challenge having to <span title='Scots slang: the act of carrying a heavy burden'>humph</span> around a clunky DSLR around all the time in Scottish weather let alone when having to chase after two young children. Which is by I tend to pickup the S20+ more often that not.
            </q>
          </p>

          <div className='columns is-multiline'>
            <article className='column is-half '>
              <ul>
                <li>Nikon Z6ii</li>
                <li>DJI Mini 4K</li>
                <li>DJI Mic 3</li>
                <li>Smallrig Magnetic Phone Mount</li>
                <li>Smallrig Cage</li>
                <li>Smallrig NATO Handle</li>
                <li>K&F Tripod</li>
                <li>K&F ND64</li>
                <li>K&F ND1000</li>
              </ul>
            </article>
          </div>
        </section>

      </main>
    </div>
  );
};

export default Uses;
